import { Component, Input } from '@angular/core';
import { IBlockUserRequest } from '../../../classes/block-user';
import { FormGroup } from '@nbg-globals/form-controls';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'lock-user-info',
	template: require('./lock-user-info.component.html'),
})
export class LockUserInfoComponent {
	@Input() controls: FormGroup<IBlockUserRequest>;
	public isRebrading = AppSettings.isRebrading;
	isAfmVisible = false;
	public userName: string = '';
	public vat: string = '';

	constructor() {}

	toggleVisibility() {
		this.isAfmVisible = !this.isAfmVisible;
	}

	public validateVat() {
		if (this.vat && this.vat.length > 0) {
			this.controls.get('vat').setValue(this.vat);
		}
	}

	public validateUsername() {
		if (this.userName && this.userName.length > 0) {
			this.controls.get('userName').setValue(this.userName);
		}
	}
}
